import { createGenericContext } from '@app/common/contexts/createGenericContext';

export interface AccountsDropDownContext {
  readonly displayHidden: boolean
  // will be typed in component AccountsDropDown.tsx
  readonly onSelect: (value: any) => void
  readonly setHasHidden: React.Dispatch<React.SetStateAction<boolean>>
  readonly setSelectedItemView: (
    React.Dispatch<React.SetStateAction<React.ReactElement<any, string | React.JSXElementConstructor<any>> | null>>
  )
  readonly value: any
}

export const [
  useAccountsDropDownContext,
  AccountsDropDownContextProvider,
] = createGenericContext<AccountsDropDownContext>();
